<template>
  <div>
    <img v-if="!settings" src="@/assets/img/spinner.gif" alt="">

  <div v-if="settings">
    <!-- Generale -->
    <form>
      <div class="card">
        <div class="card-header">
          <button
            :class="[ 'btn', selected === lang ? 'btn-primary': 'btn-outline-primary' ]"
            v-for="lang in $available_langs_code"
            v-bind:key="lang"
            @click="selected = lang"
          >{{ lang }}
          </button>

        </div>
        <div class="card-body">
          <div v-for="(value,lang) in settings.generale" v-bind:key="'tab' + lang" v-show="selected==lang">
            Generale
            <hr>
            <div class="form-group">
              <label :for="'generale-testosx-' + lang">Suffisso titolo</label>
              <input
                :id="'generale-testosx-' + lang"
                class="form-control"
                type="text"
                v-model="value.seotitle"
              />
            </div>
          </div>
          <button class="btn btn-success" @click="save('generale')"> Salva Generale</button>
        </div>
      </div>
    </form>

        <!-- Footer -->
    <form>
      <div class="card">
        <div class="card-body">
          <div v-for="(value,lang) in settings.footer" v-bind:key="'tab' + lang" v-show="selected==lang">
            Footer
            <hr>
            <div class="form-group">
              <label :for="'footer-testosx-' + lang">Testo SX</label>
              <input
                :id="'footer-testosx-' + lang"
                class="form-control"
                type="text"
                v-model="value.testo_sx"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-newsletter-' + lang">Newsletter</label>
              <input
                :id="'footer-newsletter-' + lang"
                class="form-control"
                type="text"
                v-model="value.newsletter"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-button-' + lang">Bottone</label>
              <input
                :id="'footer-button-' + lang"
                class="form-control"
                type="text"
                v-model="value.newsletter_button"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-copyright-' + lang">Copyright</label>
              <input
                :id="'footer-copyright-' + lang"
                class="form-control"
                type="text"
                v-model="value.copyright"
              />
            </div>


          </div>
          <button class="btn btn-success" @click="save('footer')"> Salva Footer</button>
        </div>
      </div>
    </form>

    <!-- ERW -->
    <form>
      <div class="card">
        <div class="card-body">
          <div v-for="(value,lang) in settings.erw" v-bind:key="'tab' + lang" v-show="selected==lang">
            Emilia Romagna Welcome
            <hr>
            <div class="form-group">
              <label :for="'erw-titolo-' + lang">Titolo</label>
              <input
                :id="'erw-titolo-' + lang"
                class="form-control"
                type="text"
                v-model="value.title"
              />
            </div>

            <div class="form-group row">
              <div class="col-md-3">
                <img class="image" :src="value.image" />
              </div>
              <div class="col-md-9">
                <textarea
                  rows="4"
                  :id="'mosaico-image-' + lang"
                  class="form-control"
                  type="text"
                  v-model="value.image"
                />
                <button class="btn btn-default" @click="pickImage(value)">Galleria</button>
              </div>
            </div>
            <div class="form-group">
              <label :for="'erw-button-' + lang">Bottone</label>
              <input
                :id="'erw-button-' + lang"
                class="form-control"
                type="text"
                v-model="value.button"
              />
            </div>

            <div class="form-group row">
            <div class="col-md-12">
              <label :for="'erw-permalink-' + lang">URL</label>
              <input
                :id="'permalink-' + lang"
                class="form-control"
                type="text"
                v-model="value.permalink"
              />
            </div>
            </div>
          </div>
          <button class="btn btn-success" @click="save('erw')"> Salva ERW</button>
        </div>
      </div>
    </form>

    <!-- Instagram -->
    <form>
      <div class="card">
        <div class="card-body">
          <div v-for="(value,lang) in settings.instagram_home" v-bind:key="'tab' + lang" v-show="selected==lang">
            Instagram
            <hr>
            <div class="form-group">
              <label :for="'footer-testosx-' + lang">Titolo</label>
              <input
                :id="'footer-testosx-' + lang"
                class="form-control"
                type="text"
                v-model="value.title"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-newsletter-' + lang">Bottone</label>
              <input
                :id="'footer-newsletter-' + lang"
                class="form-control"
                type="text"
                v-model="value.button"
              />
            </div>
          </div>
          <button class="btn btn-success" @click="save('instagram_home')"> Salva Instagram</button>
        </div>
      </div>
    </form>

    <!-- Test -->
    <form>
      <div class="card">
        <div class="card-body">
          <div v-for="(value,lang) in settings.test" v-bind:key="'tab' + lang" v-show="selected==lang">
            Test
            <hr>
            <div class="form-group">
              <label :for="'footer-testosx-' + lang">Preferenze</label>
              <input
                :id="'footer-testosx-' + lang"
                class="form-control"
                type="text"
                v-model="value.preferenze"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-testosx-' + lang">Bottone Inizio</label>
              <input
                :id="'footer-testosx-' + lang"
                class="form-control"
                type="text"
                v-model="value.start"
              />
            </div>


            <div class="form-group">
              <label :for="'footer-newsletter-' + lang">Chi</label>
              <input
                :id="'footer-newsletter-' + lang"
                class="form-control"
                type="text"
                v-model="value.chi"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-newsletter-' + lang">Notti</label>
              <input
                :id="'footer-newsletter-' + lang"
                class="form-control"
                type="text"
                v-model="value.notti"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-newsletter-' + lang">Crea Viaggio</label>
              <input
                :id="'footer-newsletter-' + lang"
                class="form-control"
                type="text"
                v-model="value.creaViaggio"
              />
            </div>
          </div>
          <button class="btn btn-success" @click="save('test')"> Salva Test</button>
        </div>
      </div>
    </form>

    <!-- Scopri -->
    <form>
      <div class="card">
        <div class="card-body">
          <div v-for="(value,lang) in settings.scopri" v-bind:key="'tab' + lang" v-show="selected==lang">
            Scopri Emilia Romagna
            <hr>
            <div class="form-group">
              <label :for="'footer-testosx-' + lang">Titolo</label>
              <input
                :id="'footer-testosx-' + lang"
                class="form-control"
                type="text"
                v-model="value.title"
              />
            </div>

            <div class="form-group">
              <label :for="'footer-newsletter-' + lang">Descrizione</label>
              <input
                :id="'footer-newsletter-' + lang"
                class="form-control"
                type="text"
                v-model="value.descrizione"
              />
            </div>
          </div>
          <button class="btn btn-success" @click="save('scopri')"> Salva Scopri</button>
        </div>
      </div>
    </form>
  </div>
  </div>
</template>
<style scoped>
  .image {
    max-height: 200px;
    width: 100%;
  }
</style>
<script>
  import axios from "axios";
  import ImagePicker from "@/components/altrama/ImagePicker.vue";
  import Vue from "vue";

  export default {
    data() {
      return {
        selected: "it",
        settings: null
      };
    },

    created: async function () {


      if (await this.$api.user.can("menu-view") == false) {
        this.$router.replace("/not-found");
        return;
      }

      this.loadData();

    },

    mounted: function () {
    },
    methods: {
      pickImage(mosaicItem) {
        var ComponentClass = Vue.extend(ImagePicker);
        var instance = new ComponentClass({
          propsData: {type: "primary"}
        });
        instance.$mount();
        instance.$on("close", function () {
          instance.$destroy();
          this.$el.parentNode.removeChild(this.$el);
        });
        instance.$on("onimage", function (image) {
          mosaicItem.image = image;
          instance.$destroy();
          this.$el.parentNode.removeChild(this.$el);
        });
        this.$el.appendChild(instance.$el);
      },
      save: function (section) {
        let self = this;
        axios({
          method: "post",
          url: this.$url + "operations/settings",
          headers: this.$config.axiosHeaders(),
          params: {
            section: section,
            data: self.settings[section]
          }
        })
          .then(function (response) {
            console.info(response);

            self.$notifyVue(
              "top",
              "center",
              "success",
              response.data.data.message,
              'ti-check'
            );


          })
          .catch(function (error) {
            self.$processError(error);
            self.$notifyVue(
              "top",
              "center",
              "success",
              error.response.data.message,
              icon
            );
          });
      },
      loadData: function () {
        let self = this;
        axios({
          method: "get",
          url: this.$url + "operations/settings",
          headers: this.$config.axiosHeaders(),
          params: {
            section: "generale,footer,erw,instagram_home,test,scopri" // elenco sezioni da richiamare
          }
        })
          .then(function (response) {
            if (response.status == 200) {
              self.settings = Object.assign({}, self.settings, response.data);
            }
          })
          .catch(function (error) {
            self.$processError(error);
            self.$notifyVue(
              "top",
              "center",
              "success",
              error.response.data.message,
              icon
            );
          });
      },
    }, // methods
    components: {
      "image-picker": ImagePicker
    }
  };
</script>
